// ExpandedBookingCard.js
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Card } from "react-bootstrap";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import PassengerDetailsModal from "./PassengerDetailsModal";
import { useTranslation } from "react-i18next";
import "./bookingDepositCard.scss";

const ExpandedBookingCard = ({ initialFormFields, onClose }) => {
  const [formFields, setFormFields] = useState(initialFormFields);
  const [noOfAdults, setNoOfAdults] = useState(
    initialFormFields.noOfAdults || 1
  );
  const [noOfChildren, setNoOfChildren] = useState(
    initialFormFields.noOfChildren || 0
  );
  const [noOfInfants, setNoOfInfants] = useState(
    initialFormFields.noOfInfants || 0
  );

  const [showModal, setShowModal] = useState(true);
  const [showPassengerDetailModal, setShowPassengerDetailModal] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getYachtInfoSellingPriceRatePlanListDetail({})).catch((error) =>
      console.error("Error fetching data:", error)
    );
  }, [dispatch]);

  const handlePassengerChange = (field, delta) => {
    if (field === "noOfAdults") {
      setNoOfAdults((prev) => Math.max(1, prev + delta)); // Adult อย่างน้อย 1 คน
    } else if (field === "noOfChildren") {
      setNoOfChildren((prev) => Math.max(0, prev + delta));
    } else if (field === "noOfInfants") {
      setNoOfInfants((prev) => Math.max(0, prev + delta));
    }
  };

  const getGuestLimit = () => {
    const ratePlans =
      todos.YachtInfoSellingPriceRatePlanListSlice
        ?.YachtInfoSellingPriceRatePlanList?.results || [];

    return ratePlans.find(
      (plan) =>
        Number(plan.id_yachtInfo) === Number(formFields?.yachtInfo) &&
        plan.rate_type?.toLowerCase?.() ===
        formFields?.typeActivity?.toLowerCase?.()
    );
  };

  const guestLimit = getGuestLimit();

  const limit = guestLimit
    ? formFields.typeActivity === "HalfDay" ||
      formFields.typeActivity === "DayTrip"
      ? guestLimit.guests_day
      : guestLimit.guests_sleeping
    : null;

  const isPassengerCountValid = () => {
    const matchedPlan = getGuestLimit();
    if (!matchedPlan) return true;

    const totalPassengers = noOfAdults + noOfChildren + noOfInfants;

    const isDayTrip =
      formFields.typeActivity === "HalfDay" ||
      formFields.typeActivity === "DayTrip";

    const limit = isDayTrip
      ? matchedPlan.guests_day
      : matchedPlan.guests_sleeping;

    return totalPassengers <= limit;
  };

  // const handleSubmit = () => {
  //   if (!isPassengerCountValid()) {
  //     setErrorMessage("จำนวนผู้โดยสารรวมเกินขีดจำกัดของกิจกรรมนี้");
  //     return;
  //   }

  //   if (noOfAdults < 1) {
  //     setErrorMessage("At least 1 Adult is required");
  //     return;
  //   }

  //   setErrorMessage("");

  //   setShowPassengerDetailModal(true);

  //   setFormFields((prev) => ({
  //     ...prev,
  //     noOfAdults,
  //     noOfChildren,
  //     noOfInfants,
  //   }));

  //   setShowModal(false);
  // };

  const handleSubmit = () => {
    if (!isPassengerCountValid()) {
      setErrorMessage("จำนวนผู้โดยสารรวมเกินขีดจำกัดของกิจกรรมนี้");
      return;
    }

    if (noOfAdults < 1) {
      setErrorMessage("At least 1 Adult is required");
      return;
    }

    setErrorMessage("");

    const updatedFormFields = {
      ...formFields,
      noOfAdults,
      noOfChildren,
      noOfInfants,
    };

    setFormFields(updatedFormFields);

    setShowModal(false);
    setShowPassengerDetailModal(true);
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="passenger-modal"
      >
        <Modal.Body>
          <div className="text-center">
            <h5 className="fw-bold text-head mb-1">{formFields.yachtName}</h5>
            {limit !== null && (
              <div className="text-muted mb-3">
                {t("Seat capacity")} : {limit} {t("pax")}
              </div>
            )}
          </div>

          {/* Adults */}
          <Card className="mb-3 passenger-card">
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="flex-center-y">
                <div className="fw-semibold">{t("Adult(s)")}</div>
                <div
                  className="text-muted small mb-0 ml-05rem"
                >
                  {t("18+ years")}
                </div>
              </div>
              <div className="quantity-control">
                {noOfAdults > 1 && (
                  <button
                    className="qty-btn"
                    onClick={() => handlePassengerChange("noOfAdults", -1)}
                  >
                    -
                  </button>
                )}
                <div className="qty-value">{noOfAdults}</div>
                <button
                  className="qty-btn"
                  onClick={() => handlePassengerChange("noOfAdults", 1)}
                >
                  +
                </button>
              </div>
            </Card.Body>
          </Card>

          {/* Children */}
          <Card className="mb-3 passenger-card">
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="flex-center-y">
                <div className="fw-semibold">{t("Child(s)")}</div>
                <div
                  className="text-muted small mb-0 ml-05rem"
                >
                  {t("2 to 18 years")}
                </div>
              </div>
              <div className="quantity-control">
                {noOfChildren > 0 && (
                  <button
                    className="qty-btn"
                    onClick={() => handlePassengerChange("noOfChildren", -1)}
                    disabled={noOfChildren <= 0}
                  >
                    -
                  </button>
                )}
                <div className="qty-value">{noOfChildren}</div>
                <button
                  className="qty-btn"
                  onClick={() => handlePassengerChange("noOfChildren", 1)}
                >
                  +
                </button>
              </div>
            </Card.Body>
          </Card>

          {/* Infants */}
          <Card className="mb-3 passenger-card">
            <Card.Body className="d-flex justify-content-between align-items-center">
              <div className="flex-center-y">
                <div className="fw-semibold">{t("Infant(s)")}</div>
                <div
                  className="text-muted small mb-0 ml-05rem"
                >
                  {t("Under 2 years")}
                </div>
              </div>
              <div className="quantity-control">
                {noOfInfants > 0 && (
                  <button
                    className="qty-btn"
                    onClick={() => handlePassengerChange("noOfInfants", -1)}
                    disabled={noOfInfants <= 0}
                  >
                    -
                  </button>
                )}
                <div className="qty-value">{noOfInfants}</div>
                <button
                  className="qty-btn"
                  onClick={() => handlePassengerChange("noOfInfants", 1)}
                >
                  +
                </button>
              </div>
            </Card.Body>
          </Card>

          {/* Error */}
          {errorMessage && (
            <div className="text-danger text-center mb-2">{errorMessage}</div>
          )}

          {/* Submit */}
          <Button
            className="w-100 mt-3 submit-btn"
            onClick={handleSubmit}
            disabled={!isPassengerCountValid()}
          >
            {t("Submit")}
          </Button>
        </Modal.Body>
      </Modal>

      <PassengerDetailsModal
        show={showPassengerDetailModal}
        onHide={() => setShowPassengerDetailModal(false)}
        formFields={formFields}
        onCloseParent={onClose}
      />
    </>
  );
};

export default ExpandedBookingCard;
